import styled, { css } from "styled-components";

export const simpleSelectStyles = {
  control: (base, state) => ({
    ...base,
    borderColor: state.isFocused ? "#4a90e2" : !state.selectProps.value ? "#dc3545" : "#ced4da",
    "&:hover": {
      borderColor: state.isFocused ? "#4a90e2" : !state.selectProps.value ? "#dc3545" : "#ced4da"
    },
    boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(74, 144, 226, 0.25)" : "none"
  }),
  singleValue: (base) => ({
    ...base,
    padding: "1px 0"
  })
};

export const deleteModalStyles = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  div[id="modal-container"] {
    background-color: var(--primary-dark-50);
    border-radius: 20px;
    width: auto;
    max-width: unset;
    border: none;
    box-shadow: 0px 0px 40px 0px var(--primary-dark-600);
  }
`;

export const InternalsLink = styled.a`
  font-family: Rubik;
  font-size: var(--fs-sm);
  color: var(--primary-blue);
  &:hover {
    color: var(--primary-blue-hover);
    text-decoration: underline;
  }
`;

export const ModalHeader = styled.h1`
  font-size: var(--fs-lg);
  font-family: Rubik;
  color: var(--primary-dark);
  font-weight: 600;
  margin: 2rem;
`;

export const ModalContent = styled.div`
  padding: 16px;
`;

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: ${({ direction }) => direction || "column"};
  flex: ${({ flex }) => flex};
  gap: 8px;
`;

export const Label = styled.label`
  font-weight: 600;
  font-size: var(--fs-base);
  color: var(--primary-dark-600);
  font-family: Rubik;
`;

export const Input = styled.input`
  padding: 8px 12px;
  border: 1px solid var(--primary-dark-200);
  border-radius: 4px;
  font-size: var(--fs-base);
  font-family: Rubik;

  &:focus {
    outline: none;
    border-color: var(--primary-blue);
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 24px;
  width: 50%;
  margin-left: auto;

  > button {
    width: fit-content;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 8px;
  width: fit-content;
  margin-left: auto;

  > button {
    width: fit-content;
  }
`;

export const Description = styled.div`
  margin-bottom: 20px;
  color: #666;
  font-size: 0.9em;
`;

export const ReadOnlyInput = styled(Input)`
  background-color: var(--neutral-gray);
  color: var(--primary-grey);
  cursor: not-allowed;

  &:focus {
    border-color: var(--primary-grey-200);
  }
`;

export const TextArea = styled.textarea`
  padding: 8px 12px;
  border: 1px solid var(--primary-dark-200);
  border-radius: 4px;
  font-size: var(--fs-base);
  min-height: 80px;
  resize: vertical;
  font-family: inherit;

  &:focus {
    outline: none;
    border-color: var(--primary-blue);
  }
`;
